import styled from 'styled-components';

export const InputRangeWrapper = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: ${(props) => (props.noMargin ? 0 : 25)}px;

  > input:first-child {
    width: 128px;
    margin-right: 30px;
    background-color: ${(props) => props.theme.colors.white};
  }
`;

export const InputLabelsWrapper = styled.div`
  padding-top: 29px;
  display: flex;
  flex-direction: column;
  width: 100%;
  > div {
    margin-top: 10px;
    display: flex;
    flex-direction: row;
    justify-content: space-between;

    label {
      margin: 0;
    }
  }
`;

export const InputRangeStyled = styled.input`
  margin: 0;
  width: 100%;
  /* height: calc(1rem + 0.4rem); */
  padding: 0;
  background-color: transparent;
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;

  &:focus {
    outline: none;
  }

  &:focus::-webkit-slider-thumb {
    box-shadow: 0 0 0 1px #fff, 0 0 0 0.2rem rgba(0, 174, 140, 0.25);
  }

  &:focus::-moz-range-thumb {
    box-shadow: 0 0 0 1px #fff, 0 0 0 0.2rem rgba(0, 174, 140, 0.25);
  }

  &:focus::-ms-thumb {
    box-shadow: 0 0 0 1px #fff, 0 0 0 0.2rem rgba(0, 174, 140, 0.25);
  }

  &::-moz-focus-outer {
    border: 0;
  }

  &::-webkit-slider-thumb {
    width: 20px;
    height: 20px;
    margin-top: -7px;
    background-color: ${(props) => props.theme.colors.primary};
    border: 0;
    border-radius: 10px;
    transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out,
      box-shadow 0.15s ease-in-out;
    -webkit-appearance: none;
    appearance: none;
    // box-shadow: 5px 0 0 ... #c7c7c7
  }

  &::-moz-range-thumb {
    width: 20px;
    height: 20px;
    background-color: ${(props) => props.theme.colors.primary};
    border: 0;
    border-radius: 10px;
    transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out,
      box-shadow 0.15s ease-in-out;
    -moz-appearance: none;
    appearance: none;
  }

  &::-ms-thumb {
    width: 20px;
    height: 20px;
    margin-top: 0;
    margin-right: 0.2rem;
    margin-left: 0.2rem;
    background-color: ${(props) => props.theme.colors.primary};
    border: 0;
    border-radius: 10px;
    transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out,
      box-shadow 0.15s ease-in-out;
    appearance: none;
  }

  @media (prefers-reduced-motion: reduce) {
    &::-webkit-slider-thumb {
      transition: none;
    }
  }

  &::-webkit-slider-thumb:active {
    background-color: ${(props) => props.theme.colors.primary40b};
  }

  &::-webkit-slider-runnable-track {
    width: 100%;
    height: 6px;
    color: transparent;
    cursor: pointer;
    background-color: #dee2e6;

    border-color: transparent;
    content: '';
  }

  @media (prefers-reduced-motion: reduce) {
    &::-moz-range-thumb {
      transition: none;
    }
  }

  &::-moz-range-thumb:active {
    background-color: ${(props) => props.theme.colors.primary40b};
  }

  &::-moz-range-track {
    width: 100%;
    height: 6px;
    color: transparent;
    cursor: pointer;
    background-color: #dee2e6;
    border-color: transparent;
  }

  &::-moz-range-progress {
    background-color: ${(props) => props.theme.colors.secondary};
    height: 6px;
  }

  @media (prefers-reduced-motion: reduce) {
    &::-ms-thumb {
      transition: none;
    }
  }

  &::-ms-thumb:active {
    background-color: ${(props) => props.theme.colors.primary40b};
  }

  &::-ms-track {
    width: 100%;
    height: 6px;
    color: transparent;
    cursor: pointer;
    background-color: transparent;
    border-color: transparent;
    border-width: 0.5rem;
  }

  &::-ms-fill-lower {
    background-color: ${(props) => props.theme.colors.secondary};
    height: 6px;
  }

  &::-ms-fill-upper {
    margin-right: 15px;
    background-color: #dee2e6;
    //  border-radius: 1rem;
  }

  &:disabled::-webkit-slider-thumb {
    background-color: #adb5bd;
  }

  &:disabled::-webkit-slider-runnable-track {
    cursor: default;
  }

  &:disabled::-moz-range-thumb {
    background-color: #adb5bd;
  }

  &:disabled::-moz-range-track {
    cursor: default;
  }

  &:disabled::-ms-thumb {
    background-color: #adb5bd;
  }
`;
